export default "__VITE_ASSET__9a1e4eb7__"